// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  useToast,
  Box,
  ModalFooter,
  ModalBody,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
} from '@chakra-ui/react';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import './index.css';
// Assets
import { MdNotificationsNone } from 'react-icons/md';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import Swal from 'sweetalert2';
import { MdLogout } from 'react-icons/md';
import { RiShieldUserLine } from 'react-icons/ri';
import routes from 'routes';
import { getUser } from 'constants/helper/authStorage';
import { clearAuth } from 'constants/helper/authStorage';

import socket from 'constants/helper/socket';
import { useQuery } from '@tanstack/react-query';
import { getUserNotificationApi } from 'api/auth.api';

export default function HeaderLinks(props) {
  const [notifications, setNotifications] = useState([]);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const toast = useToast();

  const { data: notificationData } = useQuery({
    queryKey: ['userNotifications'],
    queryFn: getUserNotificationApi,
    enabled: isNotifOpen,
  });

  React.useEffect(() => {
    if (notificationData?.data?.notification) {
      setNotifications(notificationData.data.notification);
    }
  }, [notificationData]);

  React.useEffect(() => {
    const handleNotification = (data) => {
      setNotifications((prev) => [
        {
          id: Date.now(),
          ...data,
          isNew: true,
          time: 'Just now',
        },
        ...prev,
      ]);

      // setNotificationCount((prev) => prev + 1); // logic moved to notificationCount event

      toast({
        title: 'New Notification',
        description: data.message || 'You have a new notification',
        status: 'info',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    };

    const handleNotificationCount = (data) => {
      console.log('socket event notificationCount', data);
      let count = 0;
      if (typeof data === 'object' && data !== null) {
        count = data.count ?? 0;
      } else if (typeof data === 'number') {
        count = data;
      }
      setNotificationCount(count);
    };

    socket.on('notification', handleNotification);
    socket.on('notificationCount', handleNotificationCount);

    return () => {
      socket.off('notification', handleNotification);
      socket.off('notificationCount', handleNotificationCount);
    };
  }, [toast]);

  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const notificationBg = useColorModeValue('gray.100', 'gray.700');

  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');

  const user = getUser();
  console.log(user?.name);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      html: `<strong>${user?.name?.toUpperCase()}</strong> will be logged out.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#38A169',
      cancelButtonColor: '#E53E3E',
      confirmButtonText: 'Yes, log out!',
      customClass: {
        popup: 'chakra-ui-light',
        icon: 'custom-warning-icon',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        clearAuth();

        toast({
          title: `${user?.name?.toUpperCase()} logged out.`,
          status: 'warning',
          duration: 3000,
          isClosable: true,
          position: 'top-center',
        });

        setTimeout(() => {
          window.location.href = '/auth/sign-in';
        }, 500);
      }
    });
  };
  const handleProfile = () => {
    // open profile drawer / modal / page
    console.log('Open profile');
  };

  const openNotif = () => {
    // setNotificationCount(0);
    setIsNotifOpen(true);
  };
  const closeNotif = () => {
    // setNotificationCount(0);
    setIsNotifOpen(false);
  };

  const subTextColor = useColorModeValue('gray.600', 'gray.400');
  return (
    <Flex
      w="100%"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      bg={menuBg}
      p={2}
      borderRadius="25px"
      boxShadow={shadow}
      style={{ zIndex: '9999' }}
      gap={4}
      pl={4}
      // pt={3}
    >
      <Flex
        w={{ base: '100%', md: 'auto' }}
        textAlign={{ base: 'center', md: 'left' }}
        justifyContent={{ base: 'center', md: 'center' }}
        gap={2}
        style={{
          animation: 'fadeIn 2s ease-in-out, slideIn 1s ease-out',
        }}
      >
        <Box textAlign={{ base: 'center', md: 'left' }} lineHeight="1.6">
          <Text as="h4" fontSize="16px" fontWeight="bold" color={textColor}>
            👋 Hello, {user?.name?.toUpperCase()}
          </Text>

          <Flex align="center" pl="6" gap="1">
            <Icon as={RiShieldUserLine} color={subTextColor} boxSize={4} />
            <Text
              as="p"
              fontSize="12px"
              fontWeight="medium"
              color={subTextColor}
            >
              {user?.userType?.toUpperCase()}
            </Text>
          </Flex>
        </Box>
      </Flex>

      <Flex
        w={{ sm: '100%', md: 'auto' }}
        alignItems="center"
        justifyContent="flex-end"
        flexWrap="wrap"
        gap={{ base: 1, md: 0 }}
      >
        <SidebarResponsive routes={routes} />

        <Button
          variant="no-hover"
          bg="transparent"
          p="0px"
          minW="unset"
          minH="unset"
          h="18px"
          w="max-content"
          onClick={toggleColorMode}
        >
          <Icon
            me="10px"
            h="18px"
            w="18px"
            color={navbarIcon}
            as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
          />
        </Button>
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          p="6px"
          borderRadius="full"
          w="40px"
          h="40px"
          bg={useColorModeValue('gray.300', 'whiteAlpha.500')}
          marginRight="10px"
          onClick={openNotif}
        >
          <Icon as={MdNotificationsNone} boxSize="22px" color="#4e4c4c" />

          {notificationCount > 0 && (
            <Box
              position="absolute"
              top="-5px"
              right="-5px"
              minW="18px"
              h="18px"
              px="5px"
              bg="red.500"
              color="white"
              fontSize="11px"
              fontWeight="bold"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              lineHeight="1"
            >
              {notificationCount > 99 ? '99+' : notificationCount}
            </Box>
          )}
        </Box>

        <Menu>
          <MenuButton p="0px">
            <Avatar
              _hover={{ cursor: 'pointer' }}
              color="white"
              name={user?.name}
              bg="#11047A"
              size="sm"
              w="40px"
              h="40px"
            />
          </MenuButton>

          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
          >
            <Flex flexDirection="column" p="10px" gap={1}>
              <MenuItem
                icon={<MdLogout />}
                _hover={{ bg: 'red.50', color: 'red.500' }}
                _active={{ bg: 'red.100' }}
                _focus={{ boxShadow: 'none' }}
                color="red.500"
                fontWeight="600"
                fontSize="16px"
                borderRadius="8px"
                px="10px"
                py="6px"
                onClick={handleLogout}
              >
                Log out
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </Flex>
      <Modal
        isOpen={isNotifOpen}
        onClose={closeNotif}
        isCentered
        size={{ base: 'full', md: 'md' }}
        scrollBehavior="inside"
      >
        <ModalOverlay bg="blackAlpha.600" />
        <ModalContent
          sx={{
            '@keyframes blink': {
              '0%': { opacity: 1 },
              '50%': { opacity: 0 },
              '100%': { opacity: 1 },
            },
          }}
          borderRadius="xl"
        >
          <ModalHeader>Practitioner Registrations</ModalHeader>
          <ModalCloseButton />
          <ModalBody px={4} pb={4} maxH="60vh" overflowY="auto">
            <Flex direction="column" gap={3}>
              {notifications.length === 0 && (
                <Text textAlign="center" color="gray.500" mt={4}>
                  No new notifications
                </Text>
              )}
              {notifications.map((item) => (
                <Box
                  key={item.id}
                  position="relative"
                  p={3}
                  borderRadius="md"
                  bg={notificationBg}
                >
                  <Text fontWeight="semibold">{item.title}</Text>
                  <Text fontSize="sm" color="gray.500">
                    {item.description}
                  </Text>
                  <Text fontSize="xs" color="gray.400">
                    {new Date(item.createdAt).toLocaleDateString()}
                  </Text>
                </Box>
              ))}
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button size="sm" onClick={closeNotif}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
